<section
  class="flex w-full flex-col overflow-hidden text-sm text-black outline-none focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-inset md:min-h-[175px] lg:min-h-[232px]"
  [class.clickable]="navigateOnClick"
  [class.cursor-pointer]="isCardNavigable"
  [attr.role]="isCardNavigable ? 'link' : null"
  [attr.tabindex]="isCardNavigable ? '0' : null"
  [attr.aria-label]="isCardNavigable ? accessibleLabel : null"
>
  @if (loading) {
    <div
      class="flex h-full animate-pulse flex-col"
      role="status"
      [attr.aria-label]="label ? 'Loading ' + label : 'Loading widget data'"
    >
      <div class="mb-4 flex items-center gap-2">
        <div class="h-6 w-6 rounded bg-gray-200"></div>
        <div class="h-3 w-24 rounded bg-gray-200"></div>
      </div>
      <div class="flex flex-1 flex-col justify-center gap-3">
        <div class="h-14 w-20 rounded bg-gray-200"></div>
        <div class="h-3 w-32 rounded bg-gray-200"></div>
      </div>
      <div class="mt-4 flex justify-center">
        <div class="h-4 w-20 rounded bg-gray-200"></div>
      </div>
    </div>
  } @else {
    <div class="mt-2 flex items-center gap-2 md:gap-2">
      <div class="hidden lg:block">
        <mat-icon aria-hidden="true">{{ icon || 'widgets' }}</mat-icon>
      </div>
      <span
        class="font-montserrat text-sm leading-snug font-bold uppercase md:text-base"
        >{{ label }}</span
      >
    </div>

    <div class="mt-2 flex flex-col justify-center md:flex-1">
      <div
        class="font-montserrat text-4xl leading-none font-normal tracking-[0.5px] lg:text-6xl"
      >
        {{ number || 0 }}
      </div>
      <div class="text-sm text-gray-400">
        <ng-content></ng-content>
      </div>
    </div>

    <div class="mt-4 text-sm font-bold text-[#0D62FF] uppercase">
      <a
        [routerLink]="hyperlink"
        [queryParams]="queryParams"
        [attr.tabindex]="navigateOnClick ? '-1' : null"
        [attr.aria-hidden]="navigateOnClick ? 'true' : null"
        [attr.aria-label]="!navigateOnClick ? accessibleLabel : null"
        class=""
      >
        {{ ctaText }}
        <mat-icon
          aria-hidden="true"
          class="-mt-1 !h-[14px] !w-[14px] align-middle !text-[14px] font-bold"
          >arrow_outward</mat-icon
        >
      </a>
    </div>
  }
</section>
